export const ENGLISH_LANGUAGE_ID_STORED_IN_DATABASE = 2;

export const ErrorCodes = {
    NOT_FOUND: 404,
    FORBIDDEN: 403,
};

export const ACCESS_DENIED_ROUTE = "/AccessDenied";
export const FORM_NOT_FOUND_ROUTE = "/FormNotFound";